export default "__VITE_ASSET__BFSpORwv__"